import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';

export const containerSizesShop = {
  background: '#f4f3f0',
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },
};

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',
  '.linebreak': {
    display: 'block !important',
  },
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },

  '.c1shop': {
    padding: '128px 0px 112px',
    [MediaQueries.lg]: {
      padding: '96px 0px 80px',
    },
    [MediaQueries.md]: {
      padding: '96px 0px 84px',
    },

    [MediaQueries.sm]: {
      paddingLeft: '0px',
      paddingTop: '64px',
      paddingRight: '0px',
      paddingBottom: '64px',
    },

    h1: {
      fontSize: '56px',
      fontWeight: '500',
      lineHeight: '56px',
      letterSpacing: '-1px',
      textAlign: 'center',
      marginBottom: '24px',
      marginTop: '0px',

      [MediaQueries.md]: {
        fontSize: '48px',
        lineHeight: '48px',
      },
      [MediaQueries.lg]: {
        fontSize: '48px',
        lineHeight: '48px',
      },

      'span:first-child': {
        display: 'inline',
      },

      [MediaQueries.sm]: {
        span: {
          display: 'inline',
        },
        fontSize: '40px',
        lineHeight: '40px',
        letterSpacing: '-0.3px',
        fontWeight: '500',
        textAlign: 'center',
        marginBottom: '24px',
      },
    },

    p: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'center',
      [MediaQueries.sm]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
  },
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },
});
